/*
  ONECART.TW トップ：カテゴリ常設枠の遅延読込（2026-09-14）。sections/oc-top-rail.liquid（lazy=true）とセット。
  画面に近づいたら /collections/<handle>?sort_by=…&section_id=oc-top-rail-lazy を取得してグリッドを差し替える。
  空（data-oc-empty）や取得失敗のときは枠ごと隠す。

  判定は IntersectionObserver ではなくスクロール位置で行う。
  IntersectionObserver は「交差した／しなくなった」の変化でしか通知しないため、
  ページ末尾へ一気に飛ぶと（下の範囲外 → 上の範囲外で状態が変わらず）通知が来ず、枠が永遠に空のままになった（2026-09-14 実測）。
*/
(function () {
  if (window.__ocTopLazy) return; // 枠ごとに script タグがあるので1回だけ動かす（defer なので全枠の DOM はそろっている）
  window.__ocTopLazy = true;

  var MARGIN = 600; // 画面下端からこの距離に入ったら読み込む
  var pending = Array.prototype.slice.call(document.querySelectorAll('[data-oc-top-lazy]'));
  if (!pending.length) return;

  function hideWrap(el) {
    var wrap = el.closest('[data-oc-top-lazy-wrap]');
    if (wrap) wrap.hidden = true;
  }

  function load(el) {
    el.setAttribute('data-loaded', '1');
    fetch(el.getAttribute('data-src'), { credentials: 'same-origin' })
      .then(function (res) {
        return res.ok ? res.text() : '';
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.querySelector('.oc-top-grid');
        if (!grid || doc.querySelector('[data-oc-empty]')) {
          hideWrap(el);
          return;
        }
        grid.style.setProperty('--oc-cols', el.style.getPropertyValue('--oc-cols') || '5');
        el.replaceChildren(grid);
      })
      .catch(function () {
        hideWrap(el);
      });
  }

  var ticking = false;
  function check() {
    ticking = false;
    var limit = window.innerHeight + MARGIN;
    pending = pending.filter(function (el) {
      // 画面下端＋MARGIN より上にある（＝近づいた、または通り過ぎた）枠を読み込む
      if (el.getBoundingClientRect().top < limit) {
        load(el);
        return false;
      }
      return true;
    });
    if (!pending.length) {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    }
  }
  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(check);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  check();
})();
